module.exports = __webpack_public_path__ + "static/media/giftPragmatic2.b7282b51.webp";